import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { I18nService, MessageGetter } from 'app/_services/i18n.service'
import { I18nDirective } from 'app/shared/directives/app-i18n.directive'
import { InputValidationDirective } from 'app/shared/directives/input-validation.directive'
import { TippyDirective } from 'app/shared/directives/tippy.directive'
import { FormFloatingComponent } from 'app/shared/form/form-floating/form-floating.component'

@Component({
    selector: 'form-address-location',
    templateUrl: './form-address-location.component.html',
    standalone: true,
    imports: [
        CommonModule,
        FormFloatingComponent,
        InputValidationDirective,
        ReactiveFormsModule,
        I18nDirective,
        TippyDirective,
        FontAwesomeModule,
    ],
})
export class FormAddressLocationComponent {
    @Input({ required: true }) formAddress
    @Input() postalLoading: boolean
    @Output() postalUserDontKnow = new EventEmitter<Event>()
    @Output() addressBlur = new EventEmitter<Event>()

    // Shortcut
    readonly i18n: MessageGetter = this.i18nService.getMessage.bind(this.i18nService)

    constructor(private i18nService: I18nService) {}
}
